document.addEventListener('DOMContentLoaded', () => {
  initializeFitSizes();
  initializeFitPredictor();
  initializeProductAccordion();
  startCountdownTimers();
  multiBuyAddtocart();
});
document.addEventListener('variants:change', (event) => {
  let variant = event.detail.variant;
  let form = event.detail.form;
  initializeFitSizes();
  initializeFitPredictor();
  initializePreorder(event.detail);
  multiBuyAddtocart();
});

document.addEventListener('quick:add:loaded', (event) => {
  initializeFitSizes();
  initializeFitPredictor();
  initializeProductAccordion();
  multiBuyAddtocart();
});

document.addEventListener('product:recommendations:loaded', function (event) {
  initializeStampedFnBadges();
});

// Runs Small Start
function initializeFitPredictor() {
  document.addEventListener('click', function (e) {
    const radio = e.target.closest('.size-variant-option [type="radio"]');
    if (!radio) return;

    const productInfo = radio.closest('.product-info');
    if (!productInfo) return;

    const wrappers = {
      small: productInfo?.querySelector('.runs-small-wrapper'),
      big: productInfo?.querySelector('.runs-big-wrapper')
    };

    // Get the JSON data inside the same free-product-option
    const fitDataEl = productInfo?.querySelector('.fit-predictor-json'); 
    const fitData = fitDataEl ? JSON.parse(fitDataEl.textContent) : { runSmall: [], runBig: [] };

    // Example: toggle hidden classes
    if (wrappers.small)
      wrappers.small.classList.toggle('hidden', !(fitData.runSmall || []).includes(radio.value));
    if (wrappers.big)
      wrappers.big.classList.toggle('hidden', !(fitData.runBig || []).includes(radio.value));
  });
}
// Runs Small End

// Preorder Start
function initializePreorder(detail) {
  if (!detail?.variant || !detail?.form || !window?.ProductInventory || !window?.variantStrings) return;

  const variant = detail.variant;
  const form = detail.form;
  const sectionId = form.sectionId;
  const preorderFlag = form.querySelector(`#Preorder_${sectionId}`);
  const submitButtonText = form.querySelector(`#ProductSubmitButton-${sectionId} span`);
  const stickyButtonText = document.querySelector(`.product-sticky-atc-bar .atc-btn`);
  

  // if (!preorderFlag || !submitButtonText) return;
  if (!submitButtonText) return;

  const variantData = window.ProductInventory.variants.find(v => v.id == variant.id);

  if (!variant.available){
    if(stickyButtonText){
      stickyButtonText.textContent = window.variantStrings.soldOut;
    }
  }

  if (!variant.available || !variantData) return;

  if (variantData.isPreorder) {
    submitButtonText.textContent = window.variantStrings.preorder;
    if(stickyButtonText){
      stickyButtonText.textContent = window.variantStrings.preorder;
    }
  } else {
    submitButtonText.textContent = window.variantStrings.addToCart;
    if(stickyButtonText){
      stickyButtonText.textContent = window.variantStrings.addToCart;
    }
  }
  
  if (!preorderFlag) return;
   if (variantData.isPreorder) {
    preorderFlag.classList.remove('hidden');
  } else {
    preorderFlag.classList.add('hidden');
  }
}
// Preorder End

// Fit Sizes Start
function initializeFitSizes() {
  document.addEventListener('click', function (e) {
    const radio = e.target.closest('.size-variant-option [type="radio"]');
    if (!radio) return;

    const productInfo = radio.closest('.product-info');
    if (!productInfo) return;

    const fitSizesEl = productInfo.querySelector('.fit_sizes_data');
    const fitSizesBox = productInfo.querySelector('.fit_sizes');
    const fitSizeContent = productInfo.querySelector('.fit_size_content');

    if (!fitSizesEl || !fitSizesBox || !fitSizeContent) {
      console.warn('[Fit Sizes] Scoped elements not found in product-info.');
      return;
    }

    let fitSizesData;
    try {
      fitSizesData = JSON.parse(fitSizesEl.textContent);
    } catch (err) {
      console.error('[Fit Sizes] JSON parse error:', err);
      return;
    }

    const selectedSize = radio.value.replaceAll('-', '/');
    const matchedSize = fitSizesData.find(item => item.size === selectedSize);

    if (matchedSize) {
      fitSizeContent.innerHTML = matchedSize.size_content;
      fitSizesBox.classList.remove('hidden');
    } else {
      fitSizeContent.innerHTML = '';
      fitSizesBox.classList.add('hidden');
    }
  });
}
// Fit Sizes End

// Product Details Accordion Start
function initializeProductAccordion(){
  const accordions = document.querySelectorAll('.accordion-container .product-accordion');

  accordions.forEach(accordion => {
    const heading = accordion.querySelector('.accordion-heading');
    
    // Click event for heading
    heading.addEventListener('click', function() {
      // Toggle only the clicked accordion
      if (accordion.classList.contains('open')) {
        accordion.classList.remove('open');
      } else {
        accordion.classList.add('open');
      }
    });
  });
}
// Product Details Accordion End

// Sale Timer Start
function startCountdownTimers() {
  const timers = document.querySelectorAll('.countdown-timer-wrapper');

  if (timers.length === 0) return; // Exit early if no timers found

  timers.forEach(wrapper => {
    const output = wrapper.querySelector('.timer-output');
    const endTime = wrapper.getAttribute('data-end-time');

    if (!endTime) {
      console.warn('[Countdown Timer] Missing data-end-time attribute.');
      return;
    }

    const countDownDate = new Date(endTime.replace(/\s/, 'T')).getTime();

    if (isNaN(countDownDate)) {
      console.warn('[Countdown Timer] Invalid date:', endTime);
      return;
    }

    // Remove hidden class right away if timer is valid
    wrapper.classList.remove('hidden');

    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countDownDate - now;

      if (distance < 0) {
        clearInterval(interval);
        wrapper.classList.add('hidden');
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      output.innerText = days <= 0
        ? `${hours}h ${minutes}m ${seconds}s`
        : `${days}d ${hours}h ${minutes}m ${seconds}s`;
    }, 1000);
  });
}
// Sale Timer End


// Addtocart sticky Start
$(document).ready(function () {
  $(window).on("scroll", function () {
    const headerHeight = $('sticky-header').outerHeight() || 0; // Fix: selector was missing a dot
    const $atc = $('.product-form__buttons');
    const isVisible = $atc.is(':visible');

    if (!$atc.length || !isVisible) return;

    const atcPosition = $atc.offset().top + $atc.outerHeight();

    if ($(window).scrollTop() + headerHeight > atcPosition) {
      $(".product-sticky-atc-bar").addClass("active");
      $("body").addClass("add-to-sticky");
    } else {
      $(".product-sticky-atc-bar").removeClass("active");
      $("body").removeClass("add-to-sticky");
    }
  });
  
  $('.product-sticky-atc-bar').on('click', '.add-to-btn, .add-default-btn', function () {
    const isDisabled = $(this).is('[disabled]');
    if (isDisabled) {
      const scrollPos = $('variant-selects').offset().top - ($('sticky-header').outerHeight() || 0);
      $("html, body").animate({ scrollTop: scrollPos }, 1000);
    } else {
      $('.product-form__submit').trigger('click');
    }
  });
});
// Addtocart Sticky End


// Multi Buy Products Start
document.addEventListener('cart:updated', async function(event) {
  const { detail: cartJSON, detail: { source } } = event;
  if (source === 'add-to-cart' || source === 'cart-change') {
    const cart = source === 'add-to-cart' ? await getCartJSON() : cartJSON.data;
    updateMultiBuyProduct(cart);
  }
});

async function updateMultiBuyProduct(cart) {
  if (!cart) return;

  const el = document.getElementById('multibuy-pricing-product');
  if (!el) return;
  const content = document.querySelector('.MPP-head-content');
  const mixText = el.getAttribute('mix-match-text');
  const offers = [1, 2, 3].map(i => ({
    qty: +el.getAttribute(`product-offer-${i}`),
    save: el.getAttribute(`product-offer-per-${i}`)
  }));

  if (!cart.item_count) {
    content.innerHTML = `${mixText} ${offers[0].qty} <b> save ${offers[0].save}</b>`;
    return;
  }

  let totalQty = 0, hasBundle = false;

  await Promise.all(cart.items.map(async item => {
    const product = await fetch(`/products/${item.handle}.js`).then(res => res.json());
    if (product.tags.includes('bundle')) {
      hasBundle = true;
      totalQty += item.quantity;
    }
  }));

  if (!hasBundle) {
    content.innerHTML = `${mixText} ${offers[0].qty} <b> save ${offers[0].save}</b>`;
  } else {
    const matched = offers.find(o => totalQty < o.qty) || offers[2];
    content.innerHTML = totalQty >= offers[2].qty
      ? `You've unlocked <b>${offers[2].save} off!</b>`
      : `${mixText} ${matched.qty} <b> save ${matched.save}</b>`;
  }
}
// Multi Buy Products End



document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.size-chart-content-default');
  const leftArrow = document.getElementById('leftArrow');
  const rightArrow = document.getElementById('rightArrow');

  if (!container || !leftArrow || !rightArrow) return;

  // Update arrows visibility based on scroll position
  function updateArrows() {
    const scrollLeft = container.scrollLeft;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    // Show left arrow only if not at the start
    leftArrow.style.display = scrollLeft > 5 ? 'block' : 'none';

    // Show right arrow only if not at the end
    rightArrow.style.display = scrollLeft < maxScrollLeft - 5 ? 'block' : 'none';
  }

  // Scroll actions
  leftArrow.addEventListener('click', () => {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  });

  rightArrow.addEventListener('click', () => {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  });

  // Scroll listener only for the container
  document.addEventListener('scroll', (e) => {
    const target = e.target;
    if (target.classList && target.classList.contains('size-chart-content-default')) {
      updateArrows();
    }
  }, true);

  // Initial arrow state
  updateArrows();
});

// MultiBuyAddtocart Start
function multiBuyAddtocart() {
  const addBtns = document.querySelectorAll('.custom-add-to-cart');
  const cartDrawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  addBtns.forEach((addBtn) => {
    addBtn.addEventListener('click', async () => {
      const variantId = addBtn.dataset.variantId; // from data-variant-id
      const quantity = Number(addBtn.dataset.quantity || 0);

      if(!variantId || !quantity) return;

      let formData = {
        'id': variantId,
        'quantity': quantity,
        sections: cartDrawer?.getSectionsToRender().map((section) => section.id),
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        if (cartDrawer.classList.contains("is-empty")) {
          cartDrawer.classList.remove("is-empty");
        }
        cartDrawer.renderContents(data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });
}
// MultiBuyAddtocart End

// Product Testimonial Block Start
document.addEventListener('DOMContentLoaded', function () {
  var swiper = new Swiper("#product-testimonialz .testimonial__slidez", {
    slidesPerView: 1,
    spaceBetween: 10,
    loop: false,
    followFinger: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
    },
    pagination: {
      el: "#product-testimonialz .swiper-pagination",
      clickable: true,
    },
  });
});
// Product Testimonial Block End